import React from 'react';
import { CircularProgress } from '@mui/material';

export default function AppLoader({ children, isLoading = false }) {
  return (
    <>
      {isLoading ? (
        <div style={loaderStyle}>
          <CircularProgress size={100} />
        </div>
      ) : (
        children
      )}
    </>
  );
}

const loaderStyle = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
